import { Action } from '@ngrx/store';
import { ApplicationList } from '../model/application/application-list.model';
import { ApplicationListParams } from '../model/application-list-params';

export const CHANGE_PARAMS =  '[Applications] Change Params';
export const LOAD_REQUEST =   '[Applications] Load Request';
export const LOAD_SUCCESS =   '[Applications] Load Success';
export const LOAD_ERROR =     '[Applications] Load Error';

/**
 * Action to change paging for applications.
 */
export class ChangeParamsAction implements Action {
    readonly type = CHANGE_PARAMS;

    constructor(public payload: ApplicationListParams) {}
}

/**
 * Request to load applications from server.
 */
export class LoadRequestAction implements Action {
    readonly type = LOAD_REQUEST;
}

/**
 * Application load success action.
 */
export class LoadSuccessAction implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: ApplicationList) { }
}

/**
 * * Application load error action.
 */
export class LoadErrorAction implements Action {
    readonly type = LOAD_ERROR;

    constructor(public payload: any) { }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions
    = ChangeParamsAction
    | LoadRequestAction
    | LoadSuccessAction
    | LoadErrorAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/actions/application-list.actions.ts